import { Button, Modal, SelectMenu, Typography } from '@scale/scaleui';
import { useCallback, useState } from 'react';
import { useMutateManagerInfo } from 'react-scale/components/ExpertManagement/hooks/mutations/useMutateManagerInfo';
import { useFetchUserInfo } from 'react-scale/components/ExpertManagement/hooks/queries/useFetchUserInfo';
import {
  podTypeOptionsSelector,
  useStatContextStore,
} from 'react-scale/components/ExpertManagement/stores/statContext.store';
import { shallow } from 'zustand/shallow';
import { UserInfo } from './types';

interface EditManagerInfoModalProps {
  open: boolean;
  onClose: () => void;
  userInfo: UserInfo;
}

export function EditManagerInfoModal({ open, onClose, userInfo }: EditManagerInfoModalProps) {
  const { id, teamLeadPodType } = userInfo;
  const podTypeOptions = useStatContextStore(podTypeOptionsSelector, shallow);
  const [localPodType, setPodType] = useState<string>(teamLeadPodType._id ?? '');

  const { mutateAsync, isLoading } = useMutateManagerInfo();
  const { refetch, isFetching } = useFetchUserInfo(id);

  const closeModal = useCallback(async () => {
    await refetch();
    onClose();
  }, [onClose, refetch]);

  const onSave = useCallback(async () => {
    await mutateAsync({
      workerId: id,
      podType: localPodType!,
    });
    closeModal();
  }, [closeModal, id, localPodType, mutateAsync]);

  return (
    <Modal title="Edit Reviewer Info" open={open} onClose={onClose}>
      <div
        className="flex flex-col justify-between"
        style={{ minHeight: '50vh', minWidth: '50vw' }}
      >
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <Typography.Subtitle3>Pod type:</Typography.Subtitle3>
            <SelectMenu
              placeholder="Select a pod type"
              options={podTypeOptions}
              selectedOptionId={localPodType}
              setSelected={setPodType}
            />
          </div>
        </div>
        <div className="flex justify-end gap-1">
          <Button onClick={closeModal} variant="danger">
            Cancel
          </Button>
          <Button disabled={!localPodType || isLoading || isFetching} onClick={onSave}>
            {isLoading ? 'Updating...' : 'Update Reviewer'}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
